document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.site-header__menu-toggle');
  var toggleIcon = document.getElementById('MenuToggleIcon');
  var nav = document.getElementById('MobileMenu');

  function closeMenu() {
    if (!nav) return;
    nav.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (toggleIcon) toggleIcon.src = toggleIcon.getAttribute('data-closed-icon');
  }

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);

      if (toggleIcon) {
        toggleIcon.src = isOpen
          ? toggleIcon.getAttribute('data-open-icon')
          : toggleIcon.getAttribute('data-closed-icon');
      }
    });

    // Cerrar el menú al hacer click en el fondo (fuera de las opciones)
    nav.addEventListener('click', function (e) {
      var clickedLink = e.target.closest('.site-nav__link, .site-nav__sublink');
      if (!clickedLink) {
        closeMenu();
      }
    });

    // Cerrar el menú con la tecla Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  document.querySelectorAll('.site-nav__item.has-submenu > .site-nav__link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      link.closest('.site-nav__item').classList.toggle('is-expanded');
    });
  });

  document.querySelectorAll('.site-nav__subitem.has-submenu > .site-nav__sublink').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      link.closest('.site-nav__subitem').classList.toggle('is-expanded');
    });
  });

  // ---- Esconder/mostrar la barra inferior según dirección del scroll ----
  var bottombar = document.querySelector('.site-bottombar');
  if (bottombar) {
    var lastScrollY = window.scrollY;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var currentScrollY = window.scrollY;
          var menuOpen = nav && nav.classList.contains('is-open');

          if (!menuOpen && currentScrollY > lastScrollY && currentScrollY > 80) {
            bottombar.classList.add('is-hidden');
          } else {
            bottombar.classList.remove('is-hidden');
          }

          lastScrollY = currentScrollY;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
});
